export function isBetween (value, { min, max }) {
  return (value || value === 0) && value >= min && value <= max
}

export function round (value, decimal = 0) {
  return Math.round(value * (10 ** decimal)) / (10 ** decimal)
}
